(function(){
  'use strict';
  if(window.__alouraCartPromo)return;
  window.__alouraCartPromo=true;
  function render(){
    var totals=document.querySelector('.alo-cart__totals');
    if(!totals||document.querySelector('.alo-cart__promo'))return;
    var box=document.createElement('div');
    box.className='alo-cart__promo';
    box.innerHTML='<span>−10 % avec le code</span><button type="button" data-cart-copy="ALOURA10" aria-label="Copier le code promo ALOURA10">ALOURA10<em>Copier</em></button><small>À saisir dans « Code de réduction » au moment du paiement. Une utilisation par client.</small>';
    totals.insertAdjacentElement('afterend',box);
    var btn=box.querySelector('[data-cart-copy]');
    btn.addEventListener('click',function(){
      var em=btn.querySelector('em');
      var done=function(){em.textContent='Copié ✓';setTimeout(function(){em.textContent='Copier';},2200);};
      if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText('ALOURA10').then(done).catch(done);else done();
    });
    var s=document.createElement('style');
    s.textContent='.alo-cart__promo{display:flex;flex-wrap:wrap;align-items:center;gap:8px 10px;margin:14px 0 0;padding:13px 15px;border:1px dashed #d8b3bd;border-radius:14px;background:#fff6f8;font-size:13px}.alo-cart__promo>span{font-weight:700}.alo-cart__promo button{display:inline-flex;align-items:center;gap:8px;min-height:36px;padding:6px 13px;border:1px solid #d6002f;border-radius:999px;background:#fff;color:#d6002f;font:inherit;font-weight:800;letter-spacing:.08em;cursor:pointer}.alo-cart__promo button em{font-style:normal;font-weight:600;letter-spacing:0;font-size:11px;opacity:.7}.alo-cart__promo small{flex:1 0 100%;color:#6b6b6b;font-size:11px;line-height:1.45}';
    document.head.appendChild(s);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render,{once:true});else render();
})();
